import { FormControl, InputLabel, Select, TextField, makeStyles } from '@material-ui/core';

import {
  ENTITY_STATUS_FILTERS,
  ENTITY_STATUS_FILTER_LABELS,
  EntityStatusFilter,
} from '../../../shared/constants/entity-status-filter.constants';
import {
  ALL_SEGMENT_CATEGORIES,
  SEGMENT_CATEGORIES,
  SEGMENT_CATEGORY_LABELS,
  SegmentCategoryFilter,
} from '../../constants/segment-category.constants';

const SEARCH_INPUT_ID = 'segments-search';
const CATEGORY_FILTER_INPUT_ID = 'segments-category-filter';
const STATUS_FILTER_INPUT_ID = 'segments-status-filter';

interface SegmentsListFiltersProps {
  search: string;
  categoryFilter: SegmentCategoryFilter;
  statusFilter: EntityStatusFilter;
  onSearchChange: (value: string) => void;
  onCategoryFilterChange: (value: SegmentCategoryFilter) => void;
  onStatusFilterChange: (value: EntityStatusFilter) => void;
}

const useStyles = makeStyles({
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
});

export function SegmentsListFilters({
  search,
  categoryFilter,
  statusFilter,
  onSearchChange,
  onCategoryFilterChange,
  onStatusFilterChange,
}: SegmentsListFiltersProps) {
  const classes = useStyles();

  return (
    <section className={classes.filters}>
      <TextField
        id={SEARCH_INPUT_ID}
        size="small"
        label="Rechercher"
        type="text"
        variant="outlined"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={CATEGORY_FILTER_INPUT_ID}>Catégorie</InputLabel>
        <Select
          native
          label="Catégorie"
          value={categoryFilter}
          inputProps={{ id: CATEGORY_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onCategoryFilterChange(event.target.value as SegmentCategoryFilter)
          }
        >
          <option value={ALL_SEGMENT_CATEGORIES}>Toutes</option>
          {SEGMENT_CATEGORIES.map((category) => (
            <option key={category} value={category}>
              {SEGMENT_CATEGORY_LABELS[category]}
            </option>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={STATUS_FILTER_INPUT_ID}>Statut</InputLabel>
        <Select
          native
          label="Statut"
          value={statusFilter}
          inputProps={{ id: STATUS_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onStatusFilterChange(event.target.value as EntityStatusFilter)
          }
        >
          {ENTITY_STATUS_FILTERS.map((status) => (
            <option key={status} value={status}>
              {ENTITY_STATUS_FILTER_LABELS[status]}
            </option>
          ))}
        </Select>
      </FormControl>
    </section>
  );
}
